/**
 * @generated SignedSource<<14e0846e2caff7105c4f534b1beb9824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRealtimeUpdater46BadPattern$data = {
  readonly key: string;
  readonly projectId: string;
  readonly " $fragmentType": "IssueRealtimeUpdater46BadPattern";
};
export type IssueRealtimeUpdater46BadPattern$key = {
  readonly " $data"?: IssueRealtimeUpdater46BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater46BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueRealtimeUpdater46BadPattern",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1db6a139bf8d2e3e02365ee4d7ea6d04";

export default node;
